import React from 'react'
import { useCookies } from 'react-cookie'

import Modal from 'components/elements/Modal'
import NewDeckForm from 'components/misc/NewDeckModal/NewDeckForm'

import { useActionless, useAppSelector } from 'redux/hooks'
import { TOGGLE_MODAL } from 'redux/active/actions/types'

import styles from './copyDeck.module.scss'

const CopyDeck = () => {
  const copyModal = useAppSelector(state => state.active.modals.cloneModal)

  const [toggleModal] = useActionless(TOGGLE_MODAL)

  const handleClose = () => toggleModal({ modalName: 'cloneModal', flag: false })

  return (
    <Modal open={copyModal} onClose={handleClose} modalClassName={styles.modal} closeButton>
      <CopyDeckContent onDeckCloned={handleClose} />
    </Modal>
  )
}

export default CopyDeck

type Props = {
  onDeckCloned: () => void
}

export const CopyDeckContent = ({ onDeckCloned }: Props) => {
  const [{ tbUser: username }] = useCookies(['tbUser'])

  const deckName = useAppSelector(state => state.deck.name)
  const deckId = useAppSelector(state => state.deck.id)
  const deckFormat = useAppSelector(state => state.deck.format)
  const cardPackage = useAppSelector(state => state.deck.cardPackage)

  const resourceType = cardPackage ? 'Package' : 'Deck'

  return (
    <>
      <h3>Clone {resourceType.toLocaleLowerCase()}</h3>

      {username === '' ? (
        <p>You must be logged in to use this feature</p>
      ) : (
        <NewDeckForm
          openInNewTab
          copyId={deckId}
          copyName={deckName}
          copyFormat={deckFormat}
          onCreate={onDeckCloned}
          createDeckWithCards={!deckId} // AKA - Sandbox
        />
      )}
    </>
  )
}
